/**
 * Tron Grid Animation - Products fade in with connection lines
 */

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM loaded, waiting for images...');

  // Wait for images to load before starting
  window.addEventListener('load', () => {
    console.log('Images loaded, starting animation...');

    const grid = document.querySelector('#product-grid');

    if (!grid) {
      console.log('No product grid found');
      return;
    }

    const items = Array.from(grid.querySelectorAll('.grid__item'));

    console.log(`Found ${items.length} product cards`);

    // Add animation class to grid (this hides all items via CSS)
    grid.classList.add('tron-animate-grid');

    // Create SVG canvas for connection lines
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.classList.add('tron-connection-canvas');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');

    const gridParent = grid.parentElement;
    if (gridParent && getComputedStyle(gridParent).position === 'static') {
      gridParent.style.position = 'relative';
    }
    gridParent.appendChild(svg);

    console.log('SVG canvas created');

    // Function to draw a PERFECTLY STRAIGHT line between two products (Tron light cycle style)
    function drawLine(fromItem, toItem, isMagenta = false) {
      // Get fresh measurements every time
      const fromRect = fromItem.getBoundingClientRect();
      const toRect = toItem.getBoundingClientRect();
      const svgRect = svg.getBoundingClientRect();

      // Calculate EXACT center points relative to SVG container
      const fromX = Math.round(fromRect.left - svgRect.left + fromRect.width / 2);
      const fromY = Math.round(fromRect.top - svgRect.top + fromRect.height / 2);
      const toX = Math.round(toRect.left - svgRect.left + toRect.width / 2);
      const toY = Math.round(toRect.top - svgRect.top + toRect.height / 2);

      console.log(`Drawing line from (${fromX}, ${fromY}) to (${toX}, ${toY})`);

      // Create SVG line element (using <line> for perfect straight lines)
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      line.setAttribute('x1', fromX);
      line.setAttribute('y1', fromY);
      line.setAttribute('x2', toX);
      line.setAttribute('y2', toY);
      line.classList.add('tron-connection-line');
      if (isMagenta) line.classList.add('tron-line-magenta');

      // Set stroke properties directly
      line.setAttribute('stroke', isMagenta ? 'rgba(255, 0, 170, 0.8)' : 'rgba(0, 255, 255, 0.8)');
      line.setAttribute('stroke-width', '2');
      line.setAttribute('stroke-linecap', 'round');

      svg.appendChild(line);

      // Trigger draw animation
      setTimeout(() => {
        line.classList.add('tron-line-drawing');
      }, 10);

      return new Promise(resolve => setTimeout(resolve, 300)); // Line draws in 300ms
    }

    // Animate products with branching network growth
    async function animateProducts() {
      const activated = new Set();
      const queue = [];
      const remaining = new Set(items.map((_, i) => i)); // Track unactivated indices

      // Start with first product
      await new Promise(resolve => setTimeout(resolve, 500));
      console.log('Activating root product 1...');
      items[0].classList.add('tron-node-active');
      activated.add(0);
      remaining.delete(0);
      queue.push(0);

      let connectionCount = 0;

      // Keep growing the network until all products are shown
      while (remaining.size > 0 && queue.length > 0) {
        // Get next active node to branch from
        const fromIndex = queue.shift();

        // Determine how many connections this node makes (1-3)
        const branchCount = Math.min(
          Math.floor(Math.random() * 3) + 1, // Random 1-3
          remaining.size // Don't exceed remaining items
        );

        console.log(`Product ${fromIndex + 1} branching to ${branchCount} new products...`);

        // Get next unactivated products in order
        const targets = Array.from(remaining).slice(0, branchCount);

        // Draw lines and activate targets simultaneously
        const promises = targets.map(async (toIndex, idx) => {
          // Small delay between simultaneous branches
          await new Promise(resolve => setTimeout(resolve, idx * 100));

          const isMagenta = connectionCount % 3 === 0;
          connectionCount++;

          // Draw line
          await drawLine(items[fromIndex], items[toIndex], isMagenta);

          // Activate target
          console.log(`Activating product ${toIndex + 1}...`);
          items[toIndex].classList.add('tron-node-active');
          activated.add(toIndex);
          remaining.delete(toIndex);
          queue.push(toIndex);
        });

        await Promise.all(promises);

        // Wait before next wave of growth
        await new Promise(resolve => setTimeout(resolve, 800));
      }

      // Clean up SVG after animation completes
      setTimeout(() => {
        svg.remove();
        console.log('Network growth complete, SVG removed');
      }, 3000);
    }

    animateProducts();
  });
});
